import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export class LCDQueryClient {
  constructor({
    requestClient
  }) {
    _defineProperty(this, "req", void 0);
    this.req = requestClient;
    this.distributorAccountBalance = this.distributorAccountBalance.bind(this);
    this.params = this.params.bind(this);
    this.claimRecord = this.claimRecord.bind(this);
    this.claimableForAction = this.claimableForAction.bind(this);
    this.totalClaimable = this.totalClaimable.bind(this);
    this.userVestings = this.userVestings.bind(this);
  }
  /* DistributorAccountBalance */

  async distributorAccountBalance(params) {
    const options = {
      params: {}
    };
    if (typeof (params === null || params === void 0 ? void 0 : params.airdropIdentifier) !== "undefined") {
      options.params.airdrop_identifier = params.airdropIdentifier;
    }
    const endpoint = `claim/module_account_balance`;
    return await this.req.get(endpoint, options);
  }
  /* Params */

  async params(_params = {}) {
    const endpoint = `claim/params`;
    return await this.req.get(endpoint);
  }
  /* ClaimRecord */

  async claimRecord(params) {
    const options = {
      params: {}
    };
    if (typeof (params === null || params === void 0 ? void 0 : params.airdropIdentifier) !== "undefined") {
      options.params.airdrop_identifier = params.airdropIdentifier;
    }
    const endpoint = `claim/claim_record/${params.address}`;
    return await this.req.get(endpoint, options);
  }
  /* ClaimableForAction */

  async claimableForAction(params) {
    const options = {
      params: {}
    };
    if (typeof (params === null || params === void 0 ? void 0 : params.airdropIdentifier) !== "undefined") {
      options.params.airdrop_identifier = params.airdropIdentifier;
    }
    const endpoint = `claim/claimable_for_action/${params.address}/${params.action}`;
    return await this.req.get(endpoint, options);
  }
  /* TotalClaimable */

  async totalClaimable(params) {
    const options = {
      params: {}
    };
    if (typeof (params === null || params === void 0 ? void 0 : params.airdropIdentifier) !== "undefined") {
      options.params.airdrop_identifier = params.airdropIdentifier;
    }
    if (typeof (params === null || params === void 0 ? void 0 : params.includeClaimed) !== "undefined") {
      options.params.include_claimed = params.includeClaimed;
    }
    const endpoint = `claim/total_claimable/${params.address}`;
    return await this.req.get(endpoint, options);
  }
  /* UserVestings */

  async userVestings(params) {
    const endpoint = `claim/user_vestings/${params.address}`;
    return await this.req.get(endpoint);
  }
}